import { useTranslation } from 'react-i18next';
import { FilterTabs } from 'src/components/FilterTabs/FilterTabs';
import { AccountStatusFilter } from 'src/utils/accountStatusFilter';

type Props = {
    residentMainContacts?: boolean;
    value: AccountStatusFilter;
    onChange: (value: AccountStatusFilter) => void;
};

export const AccountStatusFilterTabs = ({
    value,
    onChange,
    residentMainContacts = false,
}: Props) => {
    const { t } = useTranslation();
    const translationPrefix = residentMainContacts
        ? 'modules.users.mainContactFilters'
        : 'common.accountStatusFilters';
    return (
        <FilterTabs
            label={t(`${translationPrefix}.title`)}
            value={value}
            onChange={onChange}
            options={(['all', 'active', 'invited'] as const).map(status => ({
                value: status,
                label: t(`${translationPrefix}.${status}`),
            }))}
        />
    );
};
